"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconBlindBOL = function SvgIconBlindBOL(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "blind b o l icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Blind B O L Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.878 26.18a23.49 23.49 0 01-10.136-7.318.833.833 0 010-1.047A21.14 21.14 0 0124 9.417a20.95 20.95 0 0115.86 7.9c.392.464.695.996.895 1.57.23.659.845 1.105 1.543 1.118h.035c.909 0 1.65-.727 1.667-1.635a3.293 3.293 0 00-.65-2.023C41.038 13.262 34.535 6.083 24 6.083c-10.535 0-17.033 7.179-19.333 10.264a3.26 3.26 0 000 3.926 26.7 26.7 0 0012.123 9.06 1.667 1.667 0 101.088-3.15v-.003z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.467 17.107a.833.833 0 00.656-1.079A7.488 7.488 0 1019.5 24.295a.833.833 0 001.23-.263 13.777 13.777 0 019.737-6.925zm2.283 2.31c-6.213 0-11.25 5.036-11.25 11.25 0 6.213 5.037 11.25 11.25 11.25S44 36.88 44 30.667c-.007-6.21-5.04-11.243-11.25-11.25zm-6.593 14.978a.833.833 0 01-.61-.472 7.794 7.794 0 01-.714-3.256 7.927 7.927 0 017.917-7.917 7.81 7.81 0 013.257.713.833.833 0 01.241 1.347l-9.355 9.357a.833.833 0 01-.736.228zm6.593 4.188a7.778 7.778 0 01-3.258-.715.833.833 0 01-.242-1.346l9.355-9.355a.833.833 0 011.347.241 7.778 7.778 0 01.715 3.259 7.927 7.927 0 01-7.917 7.916z"
  }));
};

var _default = SvgIconBlindBOL;
exports.default = _default;